import React from "react";

import * as pageActions from './../actions/pageActions';

export default class Component extends React.Component {
	defaultState = {lastUpdate: null, initialized: false};

	constructor(props) {
		super(props);
		const {dispatch, page} = this.props;

		if (page.page !== window.location.pathname + window.location.search)
			dispatch(pageActions.setPage(window.location.pathname + window.location.search));

		this.initialize = this.initialize.bind(this);
		this.initialized = this.initialized.bind(this);
	}

	componentDidMount() {
		const {config} = this.props;
		
		if (config.isLoaded) {
			this.initialize(this.props, this.state);
		}
	}

	componentDidUpdate() {
		const {config} = this.props;
		var {initialized} = this.state;

		if (!initialized && config.isLoaded)
			this.initialized();
    }
    
    componentWillUnmount() {
        this.__isCancelled = true;
    }

	shouldComponentUpdate(nextProps, nextState) {
		var shouldUpdate = true;

		if (this.props.config.isLoaded !== nextProps.config.isLoaded && nextProps.config.isLoaded) {
			this.initialize(nextProps, nextState);
			shouldUpdate = false;
		}

		return shouldUpdate;
	}

	initialize(props, state) {
		var newState = {lastUpdate: new Date().getTime()};
		return newState;
	}

	// this method is called after all the javascript components are initialzed.
	// it should be called at the end of the overriden intialized function.
	initialized() {
		this.setState({initialized: true});
	}
}


// WEBPACK FOOTER //
// ./src/components/Component.js